import { useNavigateWithQuery } from '../../shared/providers/index.js';
import CommunityPlayCard from '../community-play-card/community-play-card.js';

interface Props {
    plays: any[];
    onRemove?: (play: any) => void;
}

const CommunityPlayList: FC<Props> = ({ plays, onRemove }) => {
    const navigate = useNavigateWithQuery();

    const onClick = (play) => {
        navigate('/community/play', {
            communityPlayId: play.id,
        });
    };

    return (
        <div className="community-play-list">
            {plays?.map((play) => (
                <CommunityPlayCard key={play.id} play={play} onClick={onClick} onRemove={onRemove} />
            ))}
        </div>
    );
};

export default CommunityPlayList;
